import {PenaltyDto, RewardDto} from "@/store/battle/types";
import {Creature} from "@/store/level/types";
import {Balance} from "@/store/player/types";
import {ArenaDailyRewardPanel} from "@/scenes.ui/arena-daily-reward-panel";

export interface ArenaState {
    opponent: FighterDto | undefined;
}

export class FighterDto {
    myLeague!: ArenaLeague;
    myPosition!: number;
    opponentId!: number;
    opponentName!: string;
    opponentLeague!: ArenaLeague;
    opponentPosition!: number;
    opponentLevel!: number;
    changeOpponentPrice!: number;
    changeOverCharge!: number;

    creatures!: Creature[];

    reward!: RewardDto;
    penalty!: PenaltyDto;

    speedupPrice!: number;
    rewardedEnabled!: boolean;
    rewardedWatchesToday!: number;
    rewardedWatchesMax!: number;
    arenaOpensAt!: number;
    arenaCurrBattles!: number;
    arenaMaxBattles!: number;

    dailyReward!:ArenaDailyRewardDto;

    balance!: Balance;

    opponentClan!: string;
    isMyClan!: boolean;
}

export class ArenaDailyRewardDto {
    leagueWas!: ArenaLeague;
    placeWas!: number;
    tickets!: number;
    gems!: number;
}

export class BattleLog {
    attackedByMe!: boolean;
    completedAt!: number;
    id!: number;
    myPosition!: number;
    oppPosition!: number;
    opponentGender!: string;
    opponentId!: number;
    opponentName!: string;
    winByMe!: boolean;
}


export class LeaguesDto {
    myLeague!: ArenaLeague;
    myPosition!: number;
    myBestLeague!: ArenaLeague;
    myBestPosition!: number;
    rewardHourMsk!: number;
    remainMillisToReward!: number;
    leagues!: LeagueDto[];
}

export class LeagueDto {
    league!:ArenaLeague;
    subLeagues!:SubLeagueDto[];
}

export class SubLeagueDto {
    fromPlace!:number;
    toPlace!:number;
    rewardGems!:number;
    rewardTickets!:number;
}
export enum ArenaLeague{
    FIRST = 'FIRST',
    SECOND = 'SECOND',
    THIRD = 'THIRD',
    FOURTH = 'FOURTH',
    FIFTH = 'FIFTH',
    SIXTH = 'SIXTH',
    SEVENTH = 'SEVENTH',
    EIGHTH = 'EIGHTH',
    NINTH = 'NINTH',

}
